import { useBalanceRollupStore } from "../../hooks/useBalanceRollupStore";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

type Props = {
  invertError?: boolean;
};

function ToggleSwitchRolledUp({ invertError }: Props) {
  const [isShowingRollup, isMasterSubAccount, setIsShowingRollup] =
    useBalanceRollupStore(state => [
      state.isShowingRollup,
      state.isMasterSubAccount,
      state.setIsShowingRollup,
    ]);

  if (isMasterSubAccount) {
    return (
      <ToggleSwitch
        title="Rolled-up View"
        isChecked={isShowingRollup}
        onChange={setIsShowingRollup}
      />
    );
  }

  return null;
}

export default ToggleSwitchRolledUp;
